import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { MA, Field, AssetPicker } from "@/components/ads/MetaWizard";

export const MetaAbDialog = ({ onClose, onDone }) => {
  const [f, setF] = useState({ name: "", daily_ron: 60, link: "https://www.bragus.ro", asset_ids: [], text: "", headline: "", description: "", cta: "SHOP_NOW" });
  const [links, setLinks] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { axios.get(`${MA}/link-options`).then((r) => setLinks(r.data.items)).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const toggle = (id) => setF((s) => ({ ...s, asset_ids: s.asset_ids.includes(id) ? s.asset_ids.filter((x) => x !== id) : s.asset_ids.length >= 3 ? s.asset_ids : [...s.asset_ids, id] }));
  const ai = async () => {
    setBusy("ai");
    try { const { data } = await axios.post(`${MA}/draft`, { asset_id: f.asset_ids[0] }, { timeout: 90000 });
      setF((s) => ({ ...s, name: s.name || data.name.replace("BragusApp — ", "BragusApp A/B — "), link: data.link, text: data.text, headline: data.headline, description: data.description })); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy("");
  };
  const submit = async () => {
    setBusy("save");
    try { await axios.post(`${MA}/ab-tests`, { ...f, daily_ron: Number(f.daily_ron) }, { timeout: 600000 }); toast.success("Test A/B creat pe pauză"); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message, { duration: 12000 }); }
    setBusy("");
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="meta-ab-dialog">
        <DialogHeader><DialogTitle>Test A/B creative (se creează pe pauză)</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Field label={`Alege 2–3 creative (${f.asset_ids.length}/3) — ordinea = A, B, C`}><AssetPicker value={f.asset_ids} onChange={toggle} /></Field>
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2"><Field label="Nume test"><Input data-testid="meta-ab-name" value={f.name} onChange={set("name")} /></Field></div>
            <Field label="Buget zilnic comun (lei)"><Input data-testid="meta-ab-budget" type="number" min={5} value={f.daily_ron} onChange={set("daily_ron")} /></Field>
          </div>
          <Field label="Link (produs, landing page sau site)">
            <div className="flex gap-2">
              <select data-testid="meta-ab-link-select" value={links.some((l) => l.url === f.link) ? f.link : ""} onChange={(e) => e.target.value && setF({ ...f, link: e.target.value })} className="h-9 w-64 shrink-0 rounded-md border px-2 text-sm">
                <option value="">Alege landing page…</option>{links.map((l) => <option key={l.url} value={l.url}>{l.label}</option>)}
              </select>
              <Input data-testid="meta-ab-link" value={f.link} onChange={set("link")} />
            </div>
          </Field>
          <button data-testid="meta-ab-ai-texts" type="button" onClick={ai} disabled={!f.asset_ids.length || !!busy} className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium disabled:opacity-50">
            {busy === "ai" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />} Scrie textele cu AI (după prima creativă)</button>
          <Field label="Text principal (același pentru toate creativele)"><Textarea data-testid="meta-ab-text" rows={2} value={f.text} onChange={set("text")} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Titlu"><Input data-testid="meta-ab-headline" value={f.headline} onChange={set("headline")} /></Field>
            <Field label="Descriere"><Input data-testid="meta-ab-description" value={f.description} onChange={set("description")} /></Field>
          </div>
          <p className="text-[11px] text-zinc-500">O campanie de vânzări cu un singur buget comun, un set de reclame (România 18+, Advantage+) și câte o reclamă pentru fiecare creativă. Doar imaginea/videoul diferă. După 7 zile de la pornire câștigă creativa cu cel mai bun ROAS și primești email.</p>
          <button data-testid="meta-ab-submit" onClick={submit} disabled={!!busy || f.asset_ids.length < 2} className="flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 py-2 text-sm font-semibold text-zinc-950 disabled:opacity-50">
            {busy === "save" && <Loader2 className="h-4 w-4 animate-spin" />} Creează testul pe pauză</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
